import {
  init as sentryInit,
  browserTracingIntegration,
  replayIntegration
} from '@sentry/browser';
import { captureConsoleIntegration } from '@sentry/integrations';

import getEnvironmentVariables from '@/config/environment';

const sentry = () => {
  const { ENVIRONMENT_NAME, ENABLE_SENTRY, BUILD_ID, SENTRY_DSN } =
    getEnvironmentVariables();

  if (!ENABLE_SENTRY) {
    return;
  }

  sentryInit({
    dsn: SENTRY_DSN,
    debug: false,
    release: BUILD_ID,
    environment: ENVIRONMENT_NAME,
    sampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
    maxBreadcrumbs: 100,
    normalizeDepth: 3,
    integrations: [
      browserTracingIntegration(),
      replayIntegration(),
      captureConsoleIntegration({ levels: ['error'] })
    ]
  });
};

export default sentry;
